import { render, staticRenderFns } from "./ScheduledRegistrationListModal.vue?vue&type=template&id=018a44c4&scoped=true"
import script from "./ScheduledRegistrationListModal.vue?vue&type=script&lang=js"
export * from "./ScheduledRegistrationListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018a44c4",
  null
  
)

export default component.exports